import React from 'react';

import { Typography } from 'antd';

import styled from 'styled-components';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import VerticalDate from '@components/Dates/VerticalDate';
import Money from '@components/Gui/Money';
import StyleVariables from '@components/Gui/StyleVariables.js';

/**
 * PaymentItem
 *
 * Universal component for displaying a single payment item.
 * Reusable across all contact types.
 */

const Wrapper = styled.div`
    background: #fff;
    display: flex;
    flex-direction: row;
    cursor: ${(props) => (props.$pointercursor ? 'pointer' : 'not-allowed')};
    user-select: none;
    border-bottom: ${(props) => props.theme.DefaultBorder};

    .payment-date {
        width: 8rem;
        border-right: ${(props) => props.theme.DefaultBorder};
    }

    .payment-detail {
        padding: 0.25rem 0.5rem;
        flex: 1 1 0;
        border-right: ${StyleVariables.DarkerBorder};

        small {
            font-style: italic;
            opacity: 0.75;
            display: block;
        }
    }
    .payment-totals {
        width: 10rem;
        padding: 0.25rem 0.5rem;
        text-align: right;

        span.title-span {
            text-transform: uppercase;
            font-size: ${(props) => props.theme.FontSizeSm};
            display: block;
        }
        span.money-span {
            font-weight: bold;
            display: block;
        }
    }
`;

const PaymentItem = ({ payment, onPaymentClick, hasAccountingAccess }) => {
    const handlePaymentClick = () => {
        onPaymentClick(payment.ID);
    };

    return (
        <Wrapper onClick={handlePaymentClick} $pointercursor={hasAccountingAccess}>
            <div className="payment-date">
                <VerticalDate date={payment.Date} forceShowYear />
            </div>
            <div className="payment-detail">
                <div className="contact-info">
                    {getContactName(payment.ContactID).toUpperCase()} / {payment.BillingInfo.CompanyName}
                </div>
                {payment.Name && payment.Name !== 'Payment' && <small>{payment.Name}</small>}
                {payment.Number && <Typography.Text code>{payment.Number}</Typography.Text>}
            </div>
            <div className="payment-totals">
                <span className="title-span">Total Amount</span>
                <Money amount={payment.TotalAmount} currency={payment.Currency} />
            </div>
        </Wrapper>
    );
};

export default PaymentItem;
